import { UserSystemDynamicSettingsRaw } from "../user/userDetail/UserSystemDynamicSettingsRaw";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";

interface Props {
  userId: string;
}

export const UserSubAdminSystemDynamicSettings: React.FC<Props> = ({ userId }) => {
  const activeFirm = useSelector(selectActiveFirm);

  return (
    <>
      {activeFirm?.firmGuid ? (
        <UserSystemDynamicSettingsRaw userId={userId} selectedFirmId={activeFirm?.firmGuid} />
      ) : null}
    </>
  );
};
